import StoreBadge from './StoreBadge'
export default StoreBadge
